var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$vuetify.breakpoint.mobile)?_c('div',[_c('ThermDesktop'),_c('TanksDesktop')],1):_c('div',[_c('ThermMobile'),_c('TankMobile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }